import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'count']

  connect() {
    this.update()
  }

  update() {
    if (this.hasInputTarget && this.hasCountTarget) {
      const currentLength = this.inputTarget.value.length
      const maxLength = parseInt(this.inputTarget.maxLength)

      this.countTarget.textContent = currentLength
    }
  }
}
